import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios';

Vue.use(VueI18n)

async function loadLocaleMessages () {
  // const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  // console.log('locals', locales.keys);
  // const messages = {}
  // locales.keys().forEach(key => {
  //   const matched = key.match(/([A-Za-z0-9-_]+)\./i)
  //   if (matched && matched.length > 1) {
  //     const locale = matched[1]
  //     messages[locale] = locales(key)
  //   }
  // })
  // return messages  
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en_US',
  fallbackLocale: 'en_US',
  formatFallbackMessages: false,
  fallbackWarn: false,
  missingWarn: false,
  silentTranslationWarn: true,
  // messages: loadLocaleMessages()
  messages: []
})
